export default "__VITE_ASSET__D1SkQeVl__"